/**
 * Tooltip content for the matrix line charts: the moment label and each
 * series value. Styled via CSS (no inline styles).
 *
 * @param {object} props
 * @param {boolean} [props.active] - recharts: whether the tooltip is active
 * @param {Array<{name: string, value: number, color?: string}>} [props.payload] - recharts hovered series
 * @param {string} [props.label] - recharts: x-axis label (moment)
 */
const MatrixLineTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null

  return (
    <div className='matrix-line-tooltip'>
      <div className='matrix-line-tooltip-label'>{label}</div>
      {payload.map((entry, index) => (
        <div key={`tt-${index}`} className='matrix-line-tooltip-row'>
          <span>{entry.name}</span>: {entry.value != null ? entry.value : '—'}
        </div>
      ))}
    </div>
  )
}

export default MatrixLineTooltip
